/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Button, Col, DatePicker, Form, Radio, Row, Tooltip } from 'antd';
import moment from 'moment';

import { DownloadOutlined, LoadingOutlined } from '@ant-design/icons';

import { isValidEmail } from '../../Assets/Scripts/Utils';
import useReportCooldown from '../../Hooks/useReportCooldown';
import { exportReportByEmail } from '../../Services/exportReportService';

const { RangePicker } = DatePicker;

function TaskReportForm({ loading, userEmail }) {
  const [taskForm] = Form.useForm();
  const [filterAll, setFilterAll] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const cooldownSeconds = useReportCooldown('taskReport');

  const handleExportTaskReport = async () => {
    try {
      setExportLoading(true);
      const values = await taskForm.validateFields();
      let startDateFormatted = null;
      let endDateFormatted = null;

      if (!filterAll) {
        const [startDate, endDate] = values.dateRange;
        startDateFormatted = moment(startDate).format('YYYY-MM-DDT00:00:01');
        endDateFormatted = moment(endDate).format('YYYY-MM-DDT23:59:59');
      }

      const data = { startDate: startDateFormatted, endDate: endDateFormatted };
      await exportReportByEmail('/ExportData/GenerateTaskReport', data, userEmail, 'taskReport');
    } catch (error) {
      // Validação falhou ou erro na exportação
    } finally {
      setExportLoading(false);
    }
  };

  const isButtonDisabled =
    exportLoading || loading || !isValidEmail(userEmail) || cooldownSeconds > 0;

  return (
    <Form
      form={taskForm}
      disabled={loading}
      name="taskReportForm"
      layout="vertical"
      autoComplete="off"
      initialValues={{ filterAll }}
    >
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={8} lg={7} xl={6}>
          <Form.Item
            label="Filtrar Tudo?"
            name="filterAll"
            rules={[
              {
                required: true,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Radio.Group
              options={[
                { label: 'Sim', value: true },
                { label: 'Não', value: false },
              ]}
              optionType="button"
              onChange={(val) => {
                if (val?.target?.value === true) {
                  setFilterAll(true);
                  taskForm.setFieldValue('dateRange', undefined);
                } else {
                  setFilterAll(false);
                }
              }}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={24} md={12} lg={11} xl={12}>
          <Form.Item
            label="Período"
            name="dateRange"
            rules={[
              {
                required: !filterAll,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <RangePicker
              format="DD/MM/YYYY"
              style={{ width: '100%', borderRadius: 16 }}
              popupStyle={{ borderRadius: 16, zIndex: 99999999 }}
              disabled={filterAll}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={24} md={4} lg={6} xl={6} style={{ display: 'flex', alignItems: 'center' }}>
          <Tooltip title="Baixar Relatório">
            <span style={{ display: 'inline-block', width: '100%' }}>
              <Button
                loading={exportLoading}
                type="primary"
                onClick={handleExportTaskReport}
                icon={cooldownSeconds > 0 ? <LoadingOutlined /> : <DownloadOutlined />}
                disabled={isButtonDisabled}
                style={{ width: '100%' }}
              >
                {cooldownSeconds > 0 ? `${cooldownSeconds}s` : null}
              </Button>
            </span>
          </Tooltip>
        </Col>
      </Row>
    </Form>
  );
}

export default TaskReportForm;
